import { render, staticRenderFns } from "./monthly-student-summary-report.vue?vue&type=template&id=50caf51e"
import script from "./monthly-student-summary-report.vue?vue&type=script&lang=js"
export * from "./monthly-student-summary-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports